module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.menuOpenMobile) ? _c('div', {
    staticClass: "logo-container"
  }, [_c('router-link', {
    staticClass: "logo-link",
    class: ['is-' + _vm.mode],
    attrs: {
      "to": '/' + _vm.lang
    },
    nativeOn: {
      "click": function($event) {
        _vm.onLinkClick($event)
      }
    }
  }, [_c('svg', {
    staticClass: "logo",
    attrs: {
      "width": "154px",
      "height": "16px",
      "viewBox": "0 0 154 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('polygon', {
    attrs: {
      "id": "path-1",
      "points": "14.9082191 0.1115 0.768527941 0.1115 0.768527941 15.8751125 14.9082191 15.8751125 14.9082191 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-3",
      "points": "16.4484456 15.875 0 15.875 0 0.1115 16.4484456 0.1115 16.4484456 15.875"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-5",
      "points": "14.2674206 0.1115 0.554626471 0.1115 0.554626471 15.8751125 14.2674206 15.8751125 14.2674206 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-7",
      "points": "11.7803206 0.1115 0.323173529 0.1115 0.323173529 15.829325 11.7803206 15.829325 11.7803206 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-9",
      "points": "12.6800882 15.6205125 12.6800882 0.0043875 0.813595588 0.0043875 0.813595588 15.6205125 12.6800882 15.6205125"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-11",
      "points": "13.7349882 0.1115 0.0210617647 0.1115 0.0210617647 15.8751125 13.7349882 15.8751125 13.7349882 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-13",
      "points": "0.961254412 15.875 17.4086809 15.875 17.4086809 0.1115 0.961254412 0.1115"
    }
  })]), _c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-65.000000, -71.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1-Copy",
      "transform": "translate(65.000000, 71.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-3",
      "transform": "translate(18.117647, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-1",
      "d": "M7.38260147,15.875225 L8.29527794,15.875225 C11.9799544,15.6401 14.9082191,12.594725 14.9082191,8.87435 L14.9082191,0.1106 L10.8894985,0.1106 L10.8894985,8.87435 C10.8894985,10.5461 9.52048382,11.906225 7.83893971,11.906225 C6.15626324,11.906225 4.78724853,10.5461 4.78724853,8.87435 L4.78724853,0.1106 L0.768527941,0.1106 L0.768527941,8.87435 C0.768527941,12.594725 3.69679265,15.6401 7.38260147,15.875225",
      "mask": "url(#mask-2)"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(0.000000, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-4",
      "d": "M7.93881324,5.2173125 L9.40634265,8.9466875 C8.43365147,9.0164375 7.46775441,9.1581875 6.50978382,9.3449375 L7.93881324,5.2173125 Z M4.24960735,15.8755625 L4.95053382,13.8494375 C6.90044559,13.2183125 8.91829853,12.8943125 10.9542691,12.8785625 L12.1341809,15.8755625 L16.4484456,15.8755625 L10.2431515,0.1109375 L5.45669559,0.1109375 L-0.000113235294,15.8755625 L4.24960735,15.8755625 Z",
      "mask": "url(#mask-4)"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-9",
      "transform": "translate(89.455882, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-7",
      "d": "M4.57221471,4.107725 L7.89227353,4.107725 C8.89100882,4.107725 9.70517059,4.915475 9.70517059,5.907725 C9.70517059,6.899975 8.89100882,7.707725 7.89227353,7.707725 L4.57221471,7.707725 L4.57221471,4.107725 Z M4.57221471,15.74585 L4.57221471,11.70035 L7.76658235,11.70035 L9.80368529,15.875225 L14.2674206,15.875225 L11.5882735,10.382975 C12.8904794,9.31985 13.7227588,7.70885 13.7227588,5.907725 C13.7227588,2.71385 11.1070235,0.1151 7.89227353,0.1151 L4.57221471,0.1151 L4.57221471,0.1106 L0.554626471,0.1106 L0.554626471,15.74585 L4.57221471,15.74585 Z",
      "mask": "url(#mask-6)"
    }
  })]), _c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-10",
      "d": "M61.9710721,11.919725 C59.811675,11.919725 58.0531309,10.173725 58.0531309,8.027225 C58.0531309,5.88185 59.811675,4.134725 61.9710721,4.134725 C64.1304691,4.134725 65.8878809,5.88185 65.8878809,8.027225 C65.8878809,10.173725 64.1304691,11.919725 61.9710721,11.919725 M69.9066015,8.027225 C69.9066015,3.680225 66.3464838,0.143225 61.9710721,0.143225 C57.5956603,0.143225 54.0355426,3.680225 54.0355426,8.027225 C54.0355426,12.22235 57.3522044,15.65135 61.5147338,15.888725 L62.4274103,15.888725 C66.5899397,15.65135 69.9066015,12.22235 69.9066015,8.027225"
    }
  }), _c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-12",
      "d": "M86.6954324,12.578975 L83.4172706,10.26935 C82.6801088,11.303225 81.4843441,11.919725 80.2195059,11.919725 C78.0601088,11.919725 76.3026971,10.173725 76.3026971,8.027225 C76.3026971,5.88185 78.0601088,4.134725 80.2195059,4.134725 C81.4843441,4.134725 82.6801088,4.75235 83.4172706,5.7851 L86.6954324,3.477725 C85.2063882,1.389725 82.7854176,0.143225 80.2195059,0.143225 C75.8440941,0.143225 72.2839765,3.680225 72.2839765,8.027225 C72.2839765,12.22235 75.6006382,15.65135 79.7631676,15.888725 L80.5999765,15.888725 C83.0220794,15.771725 85.2799912,14.56235 86.6954324,12.578975"
    }
  }), _c('g', {
    attrs: {
      "id": "Group-16",
      "transform": "translate(125.691176, 0.013950)"
    }
  }, [_c('polygon', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-14",
      "mask": "url(#mask-8)",
      "points": "0.323173529 0.1109375 0.323173529 15.8294375 4.34076176 15.8294375 4.34076176 10.9131875 10.2233353 10.9131875 10.2233353 6.9216875 4.34076176 6.9216875 4.34076176 4.1204375 11.7803206 4.1204375 11.7803206 0.1109375"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-19",
      "transform": "translate(140.411765, 0.138950)"
    }
  }, [_c('polygon', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-17",
      "mask": "url(#mask-10)",
      "points": "0.813595588 3.9958875 4.73833088 3.9958875 4.73833088 15.6205125 8.75591912 15.6205125 8.75591912 3.9958875 12.6806544 3.9958875 12.6806544 0.0043875 0.813595588 0.0043875"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-22",
      "transform": "translate(37.367647, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-20",
      "d": "M4.03865,4.107725 L7.35984118,4.107725 C8.35857647,4.107725 9.17160588,4.915475 9.17160588,5.907725 C9.17160588,6.899975 8.35857647,7.707725 7.35984118,7.707725 L4.03865,7.707725 L4.03865,4.107725 Z M4.03865,15.74585 L4.03865,11.70035 L7.23301765,11.70035 L9.27012059,15.875225 L13.7349882,15.875225 L11.0558412,10.382975 C12.3580471,9.320975 13.1903265,7.70885 13.1903265,5.907725 C13.1903265,2.71385 10.5745912,0.1151 7.35984118,0.1151 L4.03865,0.1151 L4.03865,0.1106 L0.0210617647,0.1106 L0.0210617647,15.74585 L4.03865,15.74585 Z",
      "mask": "url(#mask-12)"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-25",
      "transform": "translate(105.308824, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-23",
      "d": "M7.47115147,9.3449375 L8.90018088,5.2184375 L10.3677103,8.9466875 C9.39388676,9.0164375 8.42912206,9.1581875 7.47115147,9.3449375 L7.47115147,9.3449375 Z M6.41806324,0.1109375 L0.961254412,15.8755625 L5.210975,15.8755625 L5.91303382,13.8494375 C7.86068088,13.2183125 9.87966618,12.8943125 11.9145044,12.8785625 L13.0944162,15.8755625 L17.4086809,15.8755625 L11.2033868,0.1109375 L6.41806324,0.1109375 Z",
      "mask": "url(#mask-14)"
    }
  })])])])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-568053a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/elements/logo.vue
// module id = 485
// module chunks = 0